import React, { forwardRef, useState } from 'react'
import MessageBox from '../../components/CommonComponents/MessageBox'
import { IoMdInformationCircle } from "react-icons/io";
import { TbEyeClosed } from "react-icons/tb";
import { VscEye } from "react-icons/vsc";

const AdminCustomPasswordInput = forwardRef(({ isReadonly, placeHolder, onChange, name, value, className, id, onBlur, onKeyDown, error, maxLength, noMargin, noBorder, disableToggle, ...rest }, ref) => {
    const [passwordType, setPasswordType] = useState("password");

    const togglePassword = () => {
        setPasswordType(prev => prev === "password" ? "text" : "password");
    };

    const handleChange = (e) => {
        const val = e.target.value;
        if (val === '' || val.trim() !== '') {
            onChange?.(e);
        }
    };

    return (
        <div className='position-relative'>
            <input
                type={passwordType}
                name={name || ''}
                value={value || ''}
                onChange={handleChange}
                placeholder={placeHolder || 'fill the input'}
                ref={ref}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                maxLength={maxLength}
                readOnly={isReadonly}
                id={id || "inputField"}
                data-test-id={id || "inputField"}
                {...rest}
                className={`custom-input ${!noBorder ? 'custom-input-border' : ''} w-100 custom-placeholder bg-transparent theme-text-color ${className} ${!noMargin ? "mb-3" : ""} ${error ? 'custom-input-error' : ''} pe-5`}
            />

            <button
                onClick={togglePassword}
                type="button"
                className="position-absolute bg-transparent border-0 d-flex align-items-center justify-content-center"
                style={{ right: '15px', top: '15px', padding: 0, cursor: disableToggle ? 'default' : 'pointer' }}
                aria-label={passwordType === "password" ? "Show text" : "Hide text"}
                disabled={disableToggle}
            >
                {passwordType === "password" ?
                    <TbEyeClosed className="theme-text-color" size={20} /> :
                    <VscEye className="theme-text-color" size={20} />
                }
            </button>

            {error && (
                <div className='d-flex align-items-center gap-1 mb-2'>
                    <IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} />
                    <MessageBox text={`${error}`} classname='errorred d-block' />
                </div>
            )}
        </div>
    )
})

export default AdminCustomPasswordInput
